var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.29 12.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clippath);}.cls-3{fill:#fff;}.cls-4{fill:#d50a2e;}.cls-5{fill:#6fa34a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 19.29,
    height: 12.86
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m12.86,0H0v12.86h19.29V0h-6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m0,0h6.43v12.86H0V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m12.86,0h6.43v12.86h-6.43V0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalian);
export default __webpack_public_path__ + "static/media/italian.2bc17c62ce46360faf87c45046feaa82.svg";
export { ForwardRef as ReactComponent };